import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button, Dropdown, Icon } from 'semantic-ui-react';
import * as yup from 'yup';
import Axios from 'axios';

import AddTitleBar from '../../titleBar/addTitleBar';
import { createVendor } from '../../../redux/actions/vendorMasterActions';
import { AllRegex } from '../../../utils/validation';
import {INVALID_MESSAGES,REQUIRED_MESSAGES,LOCAL_STORAGE } from '../../../config/const';
import {create_edit_form, TITLES} from './vendorConstants'
import { MyNormalCheckBox } from '../../myInputs';
import UploadFile from './upload';
import moment from 'moment/moment';

const AddVendor = (props) => {
    const { createVendor } = props;
    const [vendorCategoryList, setVendorCategoryList] = useState([]);

    const getItReturnUrlImage = (imageKey) => {
        const userId = LOCAL_STORAGE.userId;
        const token = LOCAL_STORAGE.userToken;
        const customerNo = LOCAL_STORAGE.customerNo;
        return `${process.env.REACT_APP_BASE_URL}/masters/transporterMaster/getDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
    }

    const getFile = (imageKey) => {
        const userId = LOCAL_STORAGE.userId;
        const token = LOCAL_STORAGE.userToken;
        const customerNo = LOCAL_STORAGE.customerNo;
        const url = `${process.env.REACT_APP_BASE_URL}/masters/transporterMaster/getDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
        window.open(url, '_blank').focus();
    }

    const getCurrentFinancialYear = () => {
        let currentYear = new Date().getFullYear()
        let currentMonth = new Date().getMonth()
        let fromYear =currentMonth <4?currentYear -1:currentYear
        let toYear = fromYear+1

        return {
            startYear:fromYear,
            endYear:toYear
        }
    }

    useEffect(() => {
        const userId = LOCAL_STORAGE.userId;
        const token = LOCAL_STORAGE.userToken;
        const customerNo = LOCAL_STORAGE.customerNo;

        Axios.get(`${process.env.REACT_APP_BASE_URL}/masters/vendorType/0`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            params: {
                customerNo: customerNo,
                userId: userId
            }
        }).then((response => {
            let options = [];
            response.data.resultSet.map((object, index) => {
                let temp = {}
                temp.key = object.vendorTypeId
                temp.text = object.vendorType
                temp.value = object.vendorTypeId
                temp.id = object.vendorTypeId
                return options[index] = temp
            })
            setVendorCategoryList(options);
        }))
            .catch(error => {
                console.log("🚀 ~ file: addVendor.js ~ line 42 ~ useEffect ~ error", error)
            })
    }, []);

    //Formik
    const initialValues = {
        vendorName: '',
        vendorCode: '',
        vendorCompanyName: '',
        vendorContactName: '',
        vendorContactNumber: '',
        vendorAddress: '',
        panNumber: '',
        pincode: '',
        vendorTypeId: '',
        vendorMobile:'',
        vendorCity:'',
        isTDSExempted: false,
        isITReturnsFiled: false,
        tdsExemptionCertificatePath: '',
        itReturnsFilePath: '',
        tdsExemptionFinancialYearStartDate: `${getCurrentFinancialYear().startYear}-04-01`,
        tdsExemptionFinancialYearEndDate:  `${getCurrentFinancialYear().endYear}-03-31`,
        itReturnsFinancialYearStartDate: `${getCurrentFinancialYear().startYear}-04-01`,
        itReturnsFinancialYearEndDate: `${getCurrentFinancialYear().endYear}-03-31`,
    }

    const validateSchema = yup.object().shape({
        vendorCompanyName: yup.mixed().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED),
        vendorCode: yup.mixed().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED),
        vendorAddress: yup.mixed().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED),
        vendorContactNumber: yup.string().matches(AllRegex.MobileNumber, INVALID_MESSAGES.INVALID_MOBILE_NO),
        panNumber: yup.string().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED).matches(AllRegex.PANIN, INVALID_MESSAGES.INVALID_PAN_NO),
        pincode: yup.string().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED).matches(AllRegex.Pincode, INVALID_MESSAGES.INVALID_PINCODE),
        vendorTypeId: yup.mixed().optional(),
        vendorMobile:yup.string().matches(AllRegex.MobileNumber, INVALID_MESSAGES.INVALID_MOBILE_NO),
        vendorCity : yup.string().optional(),
        isTDSExempted: yup.boolean().optional(),
        tdsExemptionCertificatePath: yup.string().optional().nullable()
          .when("isTDSExempted", (isTDSExempted) =>
            isTDSExempted ? yup.string().optional().required() : yup.string().optional().nullable()
          ),
        tdsExemptionFinancialYearStartDate: yup.string().optional().nullable()
          .when("isTDSExempted", (isTDSExempted) =>
            isTDSExempted ? yup.date().optional().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED).max(new Date(`${getCurrentFinancialYear().startYear}-04-01`)) : yup.date().optional().nullable()
          ),
        tdsExemptionFinancialYearEndDate: yup.string().optional().nullable()
          .when("isTDSExempted", (isTDSExempted) =>
            isTDSExempted ? yup.string().optional().required() : yup.string().optional().nullable()
          ),
        isITReturnsFiled: yup.boolean().optional(),
        itReturnsFilePath: yup.string().optional().nullable()
          .when("isITReturnsFiled", (isITReturnsFiled) =>
            isITReturnsFiled ? yup.string().optional().required() : yup.string().optional().nullable()
          ),
        itReturnsFinancialYearStartDate: yup.string().optional().nullable()
          .when("isITReturnsFiled", (isITReturnsFiled) =>
            isITReturnsFiled ? yup.date().optional().required(REQUIRED_MESSAGES.FIELD_IS_REQUIRED).max(new Date(`${getCurrentFinancialYear().startYear}-04-01`)) : yup.date().optional().nullable()
          ),
        itReturnsFinancialYearEndDate: yup.string().optional().nullable()
          .when("isITReturnsFiled", (isITReturnsFiled) =>
            isITReturnsFiled ? yup.string().optional().required() : yup.string().optional().nullable()
          ),
    })

    const onSubmit = (values, onSubmitProps) => {
        const customerNumber = LOCAL_STORAGE.customerNo;
        const userId = LOCAL_STORAGE.userId;

        const createVendorData = {
            customerNo: customerNumber,
            userId: userId,
            companyAddress: values.vendorAddress,
            companyPincode: values.pincode,
            customerNumber: customerNumber,
            customer_no: customerNumber,
            transporterCode: values.vendorCode,
            transporterContactPerson: values.vendorContactName,
            transporterContactPersonNumber: values.vendorContactNumber,
            transporterName: values.vendorCompanyName,
            companyPan: values.panNumber,
            user_id: userId,
            vendorTypeId: values.vendorTypeId || '0',
            transporterMobile:values.vendorMobile,
            companyCity:values.vendorCity,
            isTDSExempted: values.isTDSExempted ? '1' : '0',
            isITReturnsFiled: values.isITReturnsFiled ? '1' : '0',
            ...(values.isTDSExempted ? { 
                tdsExemptionCertificatePath: values.tdsExemptionCertificatePath,
                tdsExemptionFinancialYearStartDate: values.tdsExemptionFinancialYearStartDate,
                tdsExemptionFinancialYearEndDate: values.tdsExemptionFinancialYearEndDate,
            } : {}),
            ...(values.isITReturnsFiled ? {
                itReturnsFilePath: values.itReturnsFilePath,
                itReturnsFinancialYearStartDate: values.itReturnsFinancialYearStartDate,
                itReturnsFinancialYearEndDate: values.itReturnsFinancialYearEndDate,
            } : {})
        };

        createVendor(createVendorData).then(() => {
            setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
        });

    };

    return (
        <React.Fragment>
            <AddTitleBar title="New Partner" LinkName="/partner" />
            <div className="m-2">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validateSchema}
                    onSubmit={onSubmit}
                >
                    {({ touched, errors, values, isSubmitting, handleSubmit, setFieldValue }) => (
                        <>
                            <Segment>
                                <div className="ui form tiny">
                                    <FormUi.Group >
                                        <FormUi.Field width="12">
                                            <label styles={{fontWeight: 'bold'}} className="labelName mt-2"><strong><u>{TITLES.basicDetails || "Basic Details"}</u></strong></label>
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.partner_code.title||"Partner Code"} <strong className='text-danger'>*</strong></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="vendorCode" placeholder={create_edit_form.partner_code.placeholder||"Type Code"} />
                                            {touched.vendorCode && errors.vendorCode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorCode}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.partner_company_name.title||"Partner Company Name"} <strong className='text-danger'>*</strong></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="vendorCompanyName" placeholder={create_edit_form.partner_company_name.placeholder||"Type Name"} />
                                            {touched.vendorCompanyName && errors.vendorCompanyName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorCompanyName}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.contact_person_name.title||"Contact Person Name"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="vendorContactName" placeholder={create_edit_form.contact_person_name.placeholder||"Enter Contact Person Name"} />
                                            {touched.vendorContactName && errors.vendorContactName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorContactName}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.contact_person_no.title||"Contact Person Number"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="vendorContactNumber" placeholder={create_edit_form.contact_person_no.placeholder||"Enter Contact Person Number"} />
                                            {touched.vendorContactNumber && errors.vendorContactNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorContactNumber}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.partner_address.title||"Partner Address"} <strong className='text-danger'>*</strong></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="vendorAddress" placeholder={create_edit_form.partner_address.placeholder||"Enter Address"} />
                                            {touched.vendorAddress && errors.vendorAddress ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorAddress}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.pincode.title||"Pincode"} <strong className='text-danger'>*</strong></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="pincode" placeholder={create_edit_form.pincode.placeholder||"Enter Pincode"} />
                                            {touched.pincode && errors.pincode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.pincode}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.partner_mobile.title||"Partner Mobile No"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="vendorMobile" placeholder={create_edit_form.partner_mobile.placeholder||"Enter Mobile No"} />
                                            {touched.vendorMobile && errors.vendorMobile ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorMobile}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.partner_city.title||"Partner City"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="vendorCity" placeholder={create_edit_form.partner_city.placeholder||"Enter City Name"} />
                                            {touched.vendorCity && errors.vendorCity ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorCity}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.partner_type.title||"Vendor Type"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={4}>
                                            <Dropdown
                                                id="vendorTypeId"
                                                name="vendorTypeId"
                                                clearable
                                                placeholder={create_edit_form.partner_type.placeholder||'Please select Vendor Type'}
                                                defaultValue={values.vendorTypeId}
                                                value={values.value}
                                                style={{ width: "100%", fontWeight: "normal" }}
                                                selection
                                                onChange={(name, data) => {
                                                    setFieldValue(`vendorTypeId`, data.value)
                                                }}
                                                options={vendorCategoryList}
                                            />
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="12">
                                            <label styles={{fontWeight: 'bold'}} className="labelName mt-2"><strong><u>{TITLES.financialDetails || "Financial Details"}</u></strong></label>
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.pan_no.title||"PAN Number"} <strong className='text-danger'>*</strong></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="panNumber" placeholder={create_edit_form.pan_no.placeholder||"Enter PAN"} />
                                            {touched.panNumber && errors.panNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.panNumber}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>

                                {/* TDS Exemption details */}
                                    <FormUi.Group className='mt-5'>
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.is_tds_exempted.title || "Is TDS Exempted?"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik 
                                                className='pt-2' 
                                                component={MyNormalCheckBox} 
                                                checked={values.isTDSExempted} 
                                                name="isTDSExempted"
                                            />

                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width={3}>
                                            {
                                                values.isTDSExempted == true ?
                                                <label className="labelName mt-2">
                                                    {create_edit_form.tds_exemption_certificate.title || "TDS Exemption Certificate"} <strong className='text-danger'>*</strong>
                                                </label> : null
                                            }

                                        </FormUi.Field>
                                        <FormUi.Field width="2">
                                        {
                                            values.isTDSExempted == true && <>
                                            <Fieldmik
                                                name="tdsExemptionCertificatePath"
                                                style={{ width: "23%" }}
                                                buttonName={
                                                values.tdsExemptionCertificatePath
                                                    ? "File Selected"
                                                    : "Choose File"
                                                }
                                                className="w3-button w3-round w3-small w3-border w3-hover-blue"
                                                typer={[".pdf", ".jpeg", ".jpg", ".png"]}
                                                values={values}
                                                component={UploadFile}
                                            />

                                            {touched.tdsExemptionCertificatePath && errors.tdsExemptionCertificatePath ? (
                                                <div style={{ color: 'red', fontSize: '10px' }}>
                                                {create_edit_form.tds_exemption_certificate.err_messages.rquired || "TDS Exemption Certificate is required"}
                                                </div>
                                            ) : null}
                                            
                                            
                                            </>
                                        }

                                        </FormUi.Field>
                                        {
                                            values.isTDSExempted == true &&
                                            <FormUi.Field width={2}>
                                            {
                                                    values?.tdsExemptionCertificatePath.includes('png') || values?.tdsExemptionCertificatePath.includes('jpg') ?
                                                    <a href={getItReturnUrlImage(values?.tdsExemptionCertificatePath)} target="_blank">
                                                        <img src={getItReturnUrlImage(values?.tdsExemptionCertificatePath)} style={{ height: 60, width: 60 }} />
                                                    </a>
                                                    : values?.tdsExemptionCertificatePath ? <Button
                                                        onClick={() => getFile(values?.tdsExemptionCertificatePath)}
                                                        basic
                                                        size="mini"
                                                        type="button"
                                                        icon
                                                    >
                                                        <Icon name="eye" color="blue" />
                                                    </Button> : null
                                                }
                                            </FormUi.Field>
                                        }
                                    </FormUi.Group>
                                    {/* TDS exemption dates */}
                                    {
                                      values.isTDSExempted == true &&  <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">
                                                    {create_edit_form.tds_exemption_start_date.title || "TDS Exemption Start Date"} <strong className='text-danger'>*</strong>
                                                </label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                            <Fieldmik
                                                type="date"
                                                className="ui input"
                                                name="tdsExemptionFinancialYearStartDate"
                                                onChange={(e) => {
                                                    let date = moment(e.target.value).set('month', 3).set('date', 1).format("YYYY-MM-DD");
                                                    setFieldValue("tdsExemptionFinancialYearStartDate", date);
                                                    setFieldValue("tdsExemptionFinancialYearEndDate", moment(date).add(1, "year").subtract(1, 'day').format("YYYY-MM-DD"));
                                                }}
                                                max={`${getCurrentFinancialYear().startYear}-04-01`}
                                            />
                                            <br />
                                            {touched.tdsExemptionFinancialYearStartDate && errors.tdsExemptionFinancialYearStartDate ? (
                                                <div style={{ color: 'red', fontSize: '10px' }}>
                                                {create_edit_form.tds_exemption_start_date.err_messages.rquired || "Enter Valid Date"}
                                                </div>
                                            ) : null}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width={3}>
                                                <label className="labelName mt-2">
                                                    {create_edit_form.tds_exemption_end_date.title || "TDS Exemption End Date"} <strong className='text-danger'>*</strong>
                                                </label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                            <Fieldmik
                                                disabled={true}
                                                type="date"
                                                className="ui input"
                                                name="tdsExemptionFinancialYearEndDate"
                                            />

                                            <br />
                                            {touched.tdsExemptionFinancialYearEndDate && errors.tdsExemptionFinancialYearEndDate ? (
                                                <div style={{ color: 'red', fontSize: '10px' }}>
                                                {create_edit_form.tds_exemption_end_date.err_messages.required || "TDS Exemption End Date is required"}
                                                </div>
                                            ) : null}
                                            </FormUi.Field>
                                        </FormUi.Group> 
                                    }


                                    {/* IT returns filing details */}
                                    <FormUi.Group className='mt-5'>
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">{create_edit_form.is_it_returns_filed.title || "Is IT Returns Filed?"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik 
                                                className='pt-2' 
                                                component={MyNormalCheckBox} 
                                                checked={values.isITReturnsFiled} 
                                                name="isITReturnsFiled"
                                            />
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width={3}>
                                            {
                                                values.isITReturnsFiled == true ?
                                                <label className="labelName mt-2">
                                                    {create_edit_form.it_returns_file.title || "IT Returns File"} <strong className='text-danger'>*</strong>
                                                </label> : null
                                            }

                                        </FormUi.Field>
                                        <FormUi.Field width="2">
                                        {
                                            values.isITReturnsFiled == true && <>
                                            <Fieldmik
                                                name="itReturnsFilePath"
                                                style={{ width: "23%" }}
                                                buttonName={
                                                values.itReturnsFilePath
                                                    ? "File Selected"
                                                    : "Choose File"
                                                }
                                                className="w3-button w3-round w3-small w3-border w3-hover-blue"
                                                typer={[".pdf", ".jpeg", ".jpg", ".png"]}
                                                values={values}
                                                component={UploadFile}
                                            />

                                            {touched.itReturnsFilePath && errors.itReturnsFilePath ? (
                                                <div style={{ color: 'red', fontSize: '10px' }}>
                                                {create_edit_form.it_returns_file.err_messages.required || "IT Returns File is required"} <strong className='text-danger'>*</strong>
                                                </div>
                                            ) : null}
                                            
                                            </>
                                        }

                                        </FormUi.Field>
                                        {
                                                values.isITReturnsFiled == true ?
                                        <FormUi.Field width={2}>
                                        {
                                                values?.itReturnsFilePath.includes('png') || values?.itReturnsFilePath.includes('jpg') ?
                                                <a href={getItReturnUrlImage(values?.itReturnsFilePath)} target="_blank">
                                                    <img src={getItReturnUrlImage(values?.itReturnsFilePath)} style={{ height: 60, width: 60 }} />
                                                </a>
                                                : values?.itReturnsFilePath ? <Button
                                                    onClick={() => getFile(values?.itReturnsFilePath)}
                                                    basic
                                                    size="mini"
                                                    type="button"
                                                    icon
                                                >
                                                    <Icon name="eye" color="blue" />
                                                </Button> : null
                                            }
                                        </FormUi.Field> : null }

                                    </FormUi.Group>
                                    {/*Tt returns filing dates */}
                                    {
                                      values.isITReturnsFiled == true &&  <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">
                                                    {create_edit_form.it_returns_start_date.title || "IT Returns Start Date"} <strong className='text-danger'>*</strong>
                                                </label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                            <Fieldmik
                                                type="date"
                                                className="ui input"
                                                name="itReturnsFinancialYearStartDate"
                                                onChange={(e) => {
                                                    let date = moment(e.target.value).set('month', 3).set('date', 1).format("YYYY-MM-DD");
                                                    setFieldValue("itReturnsFinancialYearStartDate", date);
                                                    setFieldValue("itReturnsFinancialYearEndDate", moment(date).add(1, 'years').subtract(1, 'days').format("YYYY-MM-DD"));
                                                }}
                                                max={`${getCurrentFinancialYear().startYear}-04-01`}
                                            />
                                            <br />
                                            {touched.itReturnsFinancialYearStartDate && errors.itReturnsFinancialYearStartDate ? (
                                                <div style={{ color: 'red', fontSize: '10px' }}>
                                                {create_edit_form.it_returns_start_date.err_messages.required || "Enter Valid Date"}
                                                </div>
                                            ) : null}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width={3}>
                                                <label className="labelName mt-2">
                                                    {create_edit_form.it_returns_end_date.title || "IT Returns End Date"} <strong className='text-danger'>*</strong>
                                                </label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                            <Fieldmik
                                                type="date"
                                                className="ui input"
                                                name="itReturnsFinancialYearEndDate"
                                                disabled={true}
                                            />

                                            <br />
                                            {touched.itReturnsFinancialYearEndDate && errors.itReturnsFinancialYearEndDate ? (
                                                <div style={{ color: 'red', fontSize: '10px' }}>
                                                {create_edit_form.it_returns_end_date.err_messages.required || "IT Returns End Date is required"}
                                                </div>
                                            ) : null}
                                            </FormUi.Field>
                                        </FormUi.Group> 
                                    }
                                    <Segment className='mt-3 pt-3' size="tiny" color="blue">Note - Branch, User and Vehicle can be added while editing Partner.</Segment>
                                </div>
                            </Segment>


                            <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                        </>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    )
}


export default connect(null, { createVendor })(AddVendor)


